import { Reveal, Eyebrow } from "@/components/Reveal";

const REVIEWS = [
  {
    id: 1,
    quote: (
      <>
        Tytöt olivat taas niin hyvillä mielin. <em className="italic">*lapsen nimi*</em>{" "}
        kysyi heti herättyään, missä Kaisa on – ja kun kuuli, että Kaisa on omassa
        kodissaan, vastaus oli ”HÖH!”. Kiitos taas hyvästä työstä, ja täällä oli
        kaikki paikatkin niin tiptop! 🫶
      </>
    ),
    author: "Lasten vanhempi",
  },
  {
    id: 2,
    quote: (
      <>
        Kiitos kun laitatte <em className="italic">*lapsen nimi*</em> kanssa paikat
        aina niin siistiksi 😉👍
      </>
    ),
    author: "Lapsen vanhempi",
  },
  {
    id: 3,
    quote: (
      <>
        Kiitos paljon vielä eilisestä. Superhienosti olit selvinnyt, vaikka
        ohjeistukseni oli vähintäänkin epämääräinen. Täällä oli myös tosi siistiä.
        Olet kyllä oikea kultakimpale! ✨
      </>
    ),
    author: "Lasten vanhempi",
  },
];

export const Testimonials = () => (
  <section id="palautteet" className="bg-greige/60 py-24 sm:py-32" data-testid="testimonials-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="mb-12 sm:mb-14">
        <Reveal>
          <Eyebrow index="02" label="Palaute" />
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 max-w-3xl font-serif text-4xl font-medium tracking-tight text-petrol-night sm:text-5xl">
            Vanhemmat kertovat
          </h2>
        </Reveal>
        <Reveal delay={0.14}>
          <p className="mt-4 text-sm text-mutedink">
            Lasten nimet on piilotettu merkinnällä *lapsen nimi*.
          </p>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-3">
        {REVIEWS.map((r, i) => (
          <Reveal key={r.id} delay={0.1 * i} className="h-full">
            <figure
              data-testid={`testimonial-card-${r.id}`}
              className="flex h-full flex-col rounded-[1.75rem] border border-line bg-cream p-8 transition-all duration-500 hover:-translate-y-1 hover:shadow-[0_30px_60px_-30px_rgba(18,58,62,0.3)] sm:p-9"
            >
              <span className="font-serif text-6xl leading-none text-beige-deep/50" aria-hidden="true">
                ”
              </span>
              <blockquote className="mt-2 font-serif text-[1.2rem] leading-relaxed text-ink/90">
                {r.quote}
              </blockquote>
              <figcaption className="mt-auto pt-7">
                <span className="block h-px w-8 bg-beige-deep/60" />
                <span className="mt-4 block text-xs font-semibold uppercase tracking-[0.2em] text-petrol/70">
                  — {r.author}
                </span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
